<template>
  <v-row class="my-1">
    <v-col class="py-0">
      <DatetimePicker
        v-model="value.date"
        style="width: 100%"
        v-bind="{ ...$attrs }"
        @input="v => handleUpdate({ value: v })"
        :textFieldProps="{
          label: lgLabel
        }"
        :disabled="formDisabled"
        auto-grow
        dense
        outlined
      ></DatetimePicker>
    </v-col>
  </v-row>
</template>

<script>
// import { now } from "@/utils/datetime"

export default {
  name: "DateField",
  components: {
    DatetimePicker: () => import("@/components/inputs/DatetimePicker.vue")
  },
  props: {
    formDisabled: { type: Boolean },
    label: { type: String, default: "" },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ value: "" }]
      }
    }
  },
  computed: {
    // lgLabel() {
    //   return `${this.label} - ${this.typename}`.toUpperCase()
    // },
    lgLabel() {
      return `${this.label}`.toUpperCase()
    },
    pValue: {
      get() {
        return this.values[0].value
      }
    }
  },
  data() {
    return {
      value: {
        // date: this.values[0].value ? this.values[0].value : now()
        date: this.values[0].value
      }
    }
  },
  methods: {
    handleUpdate(updateObj) {
      const oldObj = { id: 0, value: this.value }
      const newValue = [{ ...oldObj, ...updateObj }]
      this.$emit("input", newValue)
    }
  }
}
</script>
